import React, { useState, useEffect, Children } from 'react';
import { errorMsg, homeUrl, rearrangeArray, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import {NavbarTop} from '../ui_components/navbar_top';
import { YoutubeVideoDisplay } from '../ui_components/youtube_video_display';
import { LinkUI, LinkUIBasic, LinkUIBlueBold } from '../ui_components/common_links';
import { txb, txbb, txhb, txhbb, txrb } from '../ui_components/text_style_components';
import { BRR, ExpandCloseTab, SPACE, SPACE2 } from '../ui_components/common_ui_components';
import { isPremiumUser } from '../login/auth_utils';
import { ParkingLotQ01UI, Q03CustomerIssueResolutionUI, Q04InventoryManagementUI, Q06HitCounterUI, Q07ParkingLotStrategyPatternUI } from './prep_plan_helper_ui_classes';
import '../index.css'
import { ConnectAndBook } from '../ui_components/connect_and_book';
import { VisitPremiumSection } from '../premium/question_page_discount_ui';

function FirstPreparationPlan() {
   const prefix="roadmap1day"
   const [isPremium, setPremium] = useState(isPremiumUser());

    useEffect(() => {
    }, []) // empty bracket means there are no dependencies which will make useEffect re run

    return (
    <div className="w-full max-w-full overflow-x-hidden bg-slate-50 text-slate-900">
      <NavbarTop />

      <div className="w-full max-w-full overflow-x-hidden">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-center px-4 py-8 md:px-6 md:py-12">

          <h2 className="mt-8 mb-8 rounded-2xl border border-blue-100 bg-blue-50 px-6 py-4 text-center font-mono text-2xl font-bold leading-9 text-blue-700 shadow-sm md:text-3xl md:leading-10">
            How to Prepare for <br /> Low Level Design Interviews
          </h2>

          <Introduction /> <br />

          { false  &&
            <div className="mt-8 flex w-full max-w-3xl flex-col items-center justify-center rounded-3xl bg-yellow-100 p-8 text-center text-gray-700 shadow-sm">
             <div className=' text-xl'>
               Only Premium Members  <br />
               Can access Complete Preparation Plan

             </div>
             <br />  <br />
             <VisitPremiumSection />
             </div>
          }

          <div className="mt-8 flex w-full max-w-full flex-col items-center justify-center overflow-x-hidden text-lg">
            <div className="mb-6 text-center">
              <div className="inline-flex rounded-full bg-blue-100 px-4 py-1.5 text-sm font-bold text-blue-700">
                7-Day LLD Preparation Plan
              </div>
            </div>

            <div className="w-full space-y-4">
              <ExpandCloseTab title="Day 1 - Warming Up"
                storageKey = {prefix+"1"} children={<RoadmapDayCard>{Day1()}</RoadmapDayCard>} />

              <ExpandCloseTab title="Day 2 - Strategy Pattern"
                storageKey = {prefix+"2"} children={<RoadmapDayCard>{DayStrategyPattern()}</RoadmapDayCard>} />

              <ExpandCloseTab title="Day 3 - Observer Pattern"
                storageKey = {prefix+"3"}
                children={<RoadmapDayCard>{DayObserverPattern()}</RoadmapDayCard>} />

              <ExpandCloseTab title="Day 4 - Factory and Singleton Pattern"
                storageKey = {prefix+"4"}
                children={<RoadmapDayCard>{DayFactoryAndSingletonPattern()}</RoadmapDayCard>} />

              <ExpandCloseTab title="Day 5 - FlyWeight Pattern"
                storageKey = {prefix+"5"}
                children={<RoadmapDayCard>{DayFlyweightPattern()}</RoadmapDayCard>} />

              <ExpandCloseTab title="Day 6 - State Pattern"
                storageKey = {prefix+"6"}
                children={<RoadmapDayCard>{DayStatePattern()}</RoadmapDayCard>} />

              <ExpandCloseTab title="Day 7 - Multi-threading"
                storageKey = {prefix+"7"}
                children={<RoadmapDayCard>{DayMultithreadingAndStrategyPattern()}</RoadmapDayCard>} />
            </div>

            <br />

            <div className="mt-8 rounded-3xl border border-blue-100 bg-white px-8 py-5 text-center font-mono text-2xl font-semibold text-blue-600 shadow-sm">
              Best of Luck
            </div>

            <div className="mt-8 w-full">
              <ConnectAndBook />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function RoadmapDayCard({ children }) {
  return (
    <div className="w-full max-w-full overflow-x-hidden rounded-3xl border border-slate-200 bg-white p-4 text-sm leading-7 text-slate-800 shadow-sm md:p-7 md:text-base">
      {children}
    </div>
  );
}

function Introduction(){
  return (
    <div className='flex w-full max-w-full flex-col items-center justify-center overflow-x-hidden leading-6'>

    <div className="grid w-full grid-cols-1 items-center gap-8 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm md:grid-cols-[1.1fr_0.8fr] md:p-8">
    <div className='text-sm md:text-lg md:font-medium md:font-mono '>

    {
      <div >
        <div className='leading-relaxed'>
        This is a 7-Day plan to help you prepare  <BRR />
         for {txbb("Low Level Design Interviews")} using <BRR /> common design patterns. <br /> <br />
         It will guide you to  clear LLD rounds of <BRR />
         Microsoft, Amazon, Flipkart and other  <BRR />
         top product  companies for SDE-1, SDE-2 and <BRR />
        Senior Software Engineer positions.
          <br /> <br />
       </div>

<p className="inline-flex flex-wrap items-center rounded-2xl border border-blue-100 
bg-blue-50 px-4 py-3 shadow-sm">
  {txb('Languages:')}
 As of now only Java and Python
   are supported.   <br /></p><BRR /><BRR />

      </div>
    }

    </div>
    <div className=' flex flex-col items-center justify-center md:mx-6 '>

    <YoutubeVideoDisplay videoId="LLIPmP6p4RE"
    /><BRR /><BRR /><BRR />

    </div>

    </div>

<br />

    <div className="mt-6 grid w-full grid-cols-1 items-center gap-8 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm md:grid-cols-[0.8fr_1.1fr] md:p-8">
    <div className='flex flex-col items-center justify-center md:px-8 '>
    <YoutubeVideoDisplay videoId="knyFrpNfEp4" />
    <BRR />
    </div>


    <div className='flex flex-col items-center justify-center text-sm md:text-lg md:font-medium md:font-mono'>
      <div>
    We {txrb("won't")} be covering every detail of large systems <BRR />  like movie ticket booking system or food ordering app   <BRR />
    which can have hundreds of components and classes.
    <BRR /> <br /> <br />

      <div className="space-y-4">
        <div className="flex gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-100 text-sm font-bold text-blue-700">1</div>
          <div>
            Instead we will deep dive into the {txbb('core features')}    <BRR />
            <SPACE2 />  of these questions which interviewers expect  <BRR />
            <SPACE2 />  to discuss with you in a LLD interview.
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-100 text-sm font-bold text-blue-700">2</div>
          <div>
            YouTube videos will also teach you how to explain <BRR />
            <SPACE2 />  your solution to the interviewer {txbb('step by step.')}
          </div>
        </div>
      </div>

       <br /> <br />
       </div>
    </div>

    </div>

    <br />

  <div className="mt-6 grid w-full grid-cols-1 items-center gap-8 rounded-3xl border border-blue-100 bg-blue-50/70 p-5 shadow-sm md:grid-cols-[1.1fr_0.8fr] md:p-8">

  <div className='mx-0 md:mx-6 '>
    <div className=' font-bold text-xl mb-6'>How to Crack Low-Level Design Interviews? <BRR />  </div>
    <p className=''>Here are the
         {txbb(' four things')} you need to learn, <BRR /> to crack a low level design interview round.</p> <br />
         <div className='space-y-3 md:leading-loose'>
        <div className="rounded-2xl bg-white px-4 py-3 shadow-sm">1. How to specify core features of the question</div>
        <div className="rounded-2xl bg-white px-4 py-3 shadow-sm">2. How to break your solution in multiple classes</div>
        <div className="rounded-2xl bg-white px-4 py-3 shadow-sm">3. Usage of design patterns to solve the problem</div>
        <div className="rounded-2xl bg-white px-4 py-3 shadow-sm">
          4. How you handle multithreading
          <span className='text-gray-700 text-sm font-medium font-mono'> (optional sometimes) </span>
        </div>
        <br />
  </div>
  </div>

  <div className=' flex flex-col md:mt-4 md:mx-6'>
 <YoutubeVideoDisplay videoId="rzbEsMn-roE" />
  </div>

  </div>

    <div className='mt-6 flex w-full flex-row items-center justify-center'>

    <div className="w-full rounded-3xl border border-slate-200 bg-white p-5 text-center shadow-sm md:p-7">
      <div className='md:leading-loose justify-center items-center text-center'>
        <br />
    {txbb("Plan")} is to start each day with a few short videos
    to get you in preparation mode, <br />
    and then do one coding question covering one or more design patterns.
    <br />   <br />
    {
      <div className='text-gray-600 text-sm italic '>
    YouTube videos are free to watch, <br />
    But if you also want to practice questions, then you will need to
    <LinkUIBlueBold url = "/premium" text = "Buy Premium" />
    </div>
  }
    </div>
      <br />
    </div>
    </div>


    </div>
    );
}

/*
Important:
Keep your existing Day1, DayStrategyPattern, DayObserverPattern,
DayFactoryAndSingletonPattern, DayFlyweightPattern, DayStatePattern,
and DayMultithreadingAndStrategyPattern functions below this line exactly
as they already exist in your current file.
*/

function Day1(){
    return (
    <div className='flex flex-col  items-center justify-center'>
    <div className='flex flex-row-responsive items-center justify-center'>
    <div className='md:mr-6'>
        There are {txbb('two types')}
         of low level design interview formats: <br />
        1. 75 to 90 minutes of machine Coding <br />
        2. 45-60 minutes of face to face discussion <br />
        <br />
       Watch the adjacent Youtube Video for details.
    </div>
    <div className=' flex flex-col mt-4 md:m-6'>
    <YoutubeVideoDisplay videoId="dVjd6gFUEsA"
    />
    </div>
    </div>

  <div className='flex flex-row-reverse-responsive items-center justify-center'>
  <div className=' flex flex-col mt-4 md:px-16'>
  <YoutubeVideoDisplay videoId="ef99Ejb3B40" />
  <YoutubeVideoDisplay videoId="hWac3sK5BBo" />
  </div>

 <div>
 During LLD Interviews, it is not enough to
  just come up  <BRR />
  with a solution.  Interviewers at top product companies <BRR />
  tweak the questions and add {txbb('custom scenarios.')} <BRR />
  You should be able to change your design to handle those. <br /> <br />
  You are expected to {txbb('defend your design decisions')} <BRR />
  like why did you use a certain design pattern or <BRR />
   kept certain data inside a given class. <BRR />
  You can learn all this only through practicing questions. <br /> <br />
  Most candidates who clear FAANG/MAANG companies, practice  <BRR />
  machine coding of questions rather than just watching videos.
  </div>
    <BRR /><br />
  </div>

<br />  <BRR />

    <div className='flex flex-row-responsive  items-center justify-center'>
    <div className='md:mx-6 md:leading-loose md:justify-center md:items-center md:text-center'>
    These are the {txbb("four")} most common design patterns asked in LLD interviews.  <br />
    {txbb('Strategy,')} {txbb('Observer,')} {txbb('Factory')} and {txbb('Singleton')}   <br />

       We will practice them first and then move on to other design patterns.
    </div>

    </div>
<br /> <br />

    <div className='flex flex-row-responsive'>
    <ParkingLotQ01UI />
    </div>

    </div>
    );
}


function DayStrategyPattern(){
  return (
  <div className='flex flex-col w-full items-center justify-center'>
  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mr-6'>
    {txhbb('Strategy Design Pattern')} <br /> <br />

    Strategy Pattern is used when we need different algorithms
    <BRR /> for the same functionality.  Some examples are : <br />

      1. Different moves in chess: straight, diagonal, 2+1 move <br />
      2. different ways to order list of items <BRR />
     <SPACE2 /> e.g. by price, rating, most ordered etc

  </div>
  <div className=' flex flex-col mt-4 md:ml-6'>
  <YoutubeVideoDisplay videoId="iJkWqHw2PJc" />
 </div>
  </div>
  <BRR />  <br />
  {txbb("Practice Problem")}  <br />

  <Q07ParkingLotStrategyPatternUI />

  </div>
  );
}

function DayMultithreadingAndStrategyPattern(){
  return (
  <div className='flex flex-col w-full items-center justify-center'>

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mr-6'> <br />
    {txhbb('Multi-Threading')} <br /> <br />
    In LLD interviews, after design patterns, discussion moves on to multi-threading. <BRR />
    For these question you have to use synchronization, locks and thread safe data structures. <br /> <br />
    If you are using {txbb("Java")} then you have access to thread safe data structures   <BRR />  like  AtomicInteger, ConcurrentHashMap, ConcurrentLinkedDequeue etc.
     <br />  <br />
     <div className=''>Below are {txbb("Practice Problems")}  </div>

  </div>
  </div>
  <br />
  <Q06HitCounterUI />
  <br /> <br />
  <Q04InventoryManagementUI />
  <br /> <br />
  <Q03CustomerIssueResolutionUI />

  <br /> <br /> <br />


  </div>
  );
}

function DayFactoryAndSingletonPattern(){
  return (
  <div className='flex flex-col w-full
  items-center justify-center'>

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='mr-6'> <br />
    {txhbb('Factory Design Pattern')} <br /> <br />

    Factory Pattern is a creational design pattern and
    <BRR />  it is used to decouple  object's creation logic from their usage.
     <BRR /> This is required when we may have to create similar objects
    <BRR /> which follow the same interface or are subclasses of same superclass. <br /> <br />
    Some example are :  <br />
      - Creating different pieces in chess e.g. pawn, king, queen etc. <br />
      - Creating different type of cars in a car race video game. <br />

  </div>
 { <div className=' flex flex-col mt-4 md:ml-6'>
  <YoutubeVideoDisplay videoId="jstNvc3d69s" />
 </div>
}
  </div>
<br />

  <div className='flex flex-row-responsive items-center justify-center'>

  <div className='mr-6'>
    {txhbb('Singleton Design Pattern')} <br /> <br />

    Singleton Pattern is used when we need a
    <BRR />  single instance of an object.  <BRR />
    e.g. A connection pool manager for managing  <BRR />  database connection will be a singleton.  <br />
    Generally factories are implemented as a singleton <br />
  </div>
    <div className=' flex flex-col mt-4 md:ml-6'>
  <YoutubeVideoDisplay videoId="MCvV_MLJ0Z0" />

 </div>

 </div>
  <br />

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mx-12'>{txbb("Practice Problem")}  <br />
  {txb("Design Chess Game")} <br />
  <LinkUI url="https://codezym.com/question/8" />  <br /><br />
  In Low Level Design of chess we use following design patterns <br />
   1. Chess Piece Factory to create different   <BRR />
   chess piece objects like king, queen, pawn etc <br />  <br />
   2. Strategy pattern to implement different moves   <BRR />
   e.g. straight move, diagonal move etc.  <br /> <br />
    3. Singleton pattern to ensure there is a  <BRR />
    single instance of chess piece factory object.  <br />
    Actually this question also serves as a {txbb('counter example')}
      <BRR />  as to where we should not use singleton pattern.  <br />  <br />
    Even though we need only once instance of Chess Piece Factory  <BRR />
    but it is being used from only one place as you will see in solution videos.   <BRR />
    So making ChessPieceFactory a singleton is unnecessary in this case.

   <br /> <br />
  </div>
  <div className='flex flex-col'>
  <br />  <BRR />
    <YoutubeVideoDisplay videoId='VWUuQWxmXYQ' />
    <BRR />
    <YoutubeVideoDisplay videoId='6HYvoBv78VU' />
    </div>
  </div>

  </div>
  );
}

function DayFlyweightPattern(){
  return (
  <div className='flex flex-col w-full
  items-center justify-center'>

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='mr-6'> <br />
    {txhbb('Flyweight Design Pattern')} <br /> <br />

    Flyweight design pattern is used when we need to
    <BRR />    create a large number of
    similar objects   <BRR /> It helps us save memory space
    by sharing   <BRR /> constant state among objects.
     <br /> <br />
     <SPACE /> Some examples are <br />
      - Sharing 3-d images of thousands of soldiers <BRR />
      <SPACE /> in a computer war game
       <br />
      - Sharing styles of characters in a
      text editor <BRR />
      <SPACE /> like Microsoft word.
       <br />

  </div>
  <div className=' flex flex-col items-center mt-4 md:ml-6'>
  <YoutubeVideoDisplay videoId="ca82h-4c72g"
  />

 </div>
  </div>
<br />

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mx-12 '>{txbb("Practice Problem")}  <br />
  {txb("Design a Text Editor/Word Processor like Microsoft Word")} <br />
  <LinkUI url="https://codezym.com/question/9" />  <br /><br />
  In a text editor, each character can have a different style  <BRR />
   in terms of parameter like colour, font size etc <br />
    <br />
   Also there can be millions of characters in a text editor file,
   <BRR />
   but total number of different styles used will be just from
   <BRR /> a few 100's to a few 1000's <br />  <br />
   So it makes sense to share character style as constant intrinsic state
   <BRR /> and reduce memory footprint of program <br />
  </div>
  <div className='flex flex-col justify-center items-center md:mx-12'>
  <div><YoutubeVideoDisplay videoId='QG0OuN-57ks' /></div>
  <br />
  <div><YoutubeVideoDisplay videoId='hmQw5DfiRws' /></div>
  </div>
  </div>

  </div>
  );
}

function DayObserverPattern(){
  return (
  <div className='flex flex-col w-full
  items-center justify-center'>

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mr-6'> <br />
    {txhbb('Observer Design Pattern')} <br /> <br />

    Observer Pattern is a behavioural design pattern and  <BRR />
    it is used when you want to have loose coupling  <BRR />  between data which is getting changed and  <BRR />  multiple views or observers which need to receive the changes. <br /> <br />
    {txb('example:')} Giving 1 to 5 star rating to a product on ecommerce website  <BRR /> needs to be observed by the class which shows list of top rated products.
    <br /> <br />
    Observer pattern is generally used along with {txb('strategy pattern')}
    <BRR />  to inform different strategy classes about  <BRR />   changes occurring in the common data structure. <br /> <br />
     {txb('example:')} a customer support system may have different strategy classes
     <BRR />    to assign an agent to a customer support call. <BRR />
    Also each  strategy need to be informed whenever  <BRR />   an agent is assigned a case so that they can decide  <BRR />  whether to assign new cases to this agent or not. <br />
    Observer pattern will be used in this case.

    <br />  <BRR />
  </div>
  <div className='flex flex-col mt-4 md:ml-6'>
  <YoutubeVideoDisplay videoId="jEfs2LpmFuo" />
 </div>

  </div>
<br />

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mx-12'>{txbb("Practice Problem")}  <br />
  {txb("Design a food ordering and rating system like ")} <BRR />
  <SPACE /> {txb("Zomato, Swiggy,  DoorDash")} <br />
  <LinkUI url="https://codezym.com/question/5" />  <br /><br />
  This system will have functionality to order food, rate orders  <BRR />
  and list top restaurants based on their rating <br /><br />
  Now whenever an order is rated then it has to observed  <BRR />
  by classes which return top restaurants lists based on their rating.  <BRR />
  So this is an ideal use case for {txb('observer design pattern')}
  <br /> <br />
    Watch {txbb("Java")} and {txbb("Python")} video solutions for explanation.
   <br /> <br />
  </div>
  <div className='flex flex-col'>
    <YoutubeVideoDisplay videoId='v9ehOtY_x7Q' />
  <SPACE2 />
  <YoutubeVideoDisplay videoId='KGN-pSlMZgg' />
  </div>
  </div>

  </div>
  );
}

function DayStatePattern(){
  return (
  <div className='flex flex-col w-full
  items-center justify-center'>
  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mr-6'> <br />
    {txhbb('State Design Pattern')} <br /> <br />

    State is a behavioural design pattern and it is used when
     <BRR /> an object has to change its behaviour as its internal state changes.
     <br />  <br />
    {txb('For example')} an ATM machine may be in different states
    <BRR />  like idle, money withdrawal in progress, validating pin etc
    <BRR />  and will respond to keyboard button presses differently in each state.   <BRR />
    The same keyboard can be used to input user's PIN as well as   <BRR />   mobile number,
    depending on the current state of ATM.
    <br /> <br />
    {txb('another example')} is of a Cab booking System.  <BRR />
    Ride can be in states like: <BRR /> Ride Requested, Ongoing, Finished, Cancelled  <BRR />
      which will have multiple states and in each of these states  <BRR />
       calculation for a common behaviour like  <BRR />
      {txb(' timeTakenToReachDestaination()')} will be different.

    <br />  <BRR />
  </div>
  <div className='flex flex-col mt-4 md:ml-6'>
  <YoutubeVideoDisplay videoId="HRnq_aeMraM" />
 </div>
  </div>

<br />

  <div className='flex flex-row-responsive items-center justify-center'>
  <div className='md:mx-12'>{txbb("Practice Problem")}  <br />
  {txb("Design an elevator management System with multiple lifts")} <br />
  <LinkUI url="https://codezym.com/question/11" />  <br /><br />
  A lift in an elevator system can be in one of three states.   <BRR />
  {txb('Moving Up,')} {txb('Moving Down')} and {txb('Idle')}    <BRR />
  And in each state it will behave differently in taking decisions
   like   <BRR />
  whether to stop on a floor, add a new request or not etc  <br /> <br />
  So we will use {txb('state design pattern')} to solve this problem.
   <br />  <BRR />
  </div>
  <div className='flex flex-col items-center justify-center'>
  <YoutubeVideoDisplay videoId='zieb_0WujWY' />
  <BRR />
    <YoutubeVideoDisplay videoId='dCjWFcE1mZ4' />
    </div>
  </div>

  </div>
  );
}

export {FirstPreparationPlan}